<div [class.full-screen]="!inline" class="page-loader d-flex align-items-center justify-content-center">
    <app-loading *ngIf="isLoaderVisible" [color]="color" class="d-inline-block"></app-loading>
</div>
